/**
 * Seções do painel admin (troca por estado, sem alterar rota).
 */

export const ADMIN_SECTION = {
  DASHBOARD: 'dashboard',
  RELATORIOS: 'relatorios',
  PLANOS: 'planos',
  DESPESAS: 'despesas',
  USUARIOS: 'usuarios',
  SERVICOS: 'servicos',
  LEMBRETES: 'lembretes',
  PERIODIZACAO_LEMBRETES: 'periodizacao-lembretes',
  TERMOS_USO: 'termos-uso',
  POLITICA_PRIVACIDADE: 'politica-privacidade',
} as const;

export type AdminSectionId = (typeof ADMIN_SECTION)[keyof typeof ADMIN_SECTION];

export interface AdminSectionItem {
  id: AdminSectionId;
  label: string;
  iconName: string;
}

export const ADMIN_SECTIONS: AdminSectionItem[] = [
  { id: ADMIN_SECTION.DASHBOARD, label: 'Dashboard', iconName: 'HomeIcon' },
  { id: ADMIN_SECTION.RELATORIOS, label: 'Relatórios', iconName: 'DocumentTextIcon' },
  { id: ADMIN_SECTION.USUARIOS, label: 'Usuários', iconName: 'UserGroupIcon' },
  { id: ADMIN_SECTION.SERVICOS, label: 'Serviços', iconName: 'WrenchScrewdriverIcon' },
  { id: ADMIN_SECTION.LEMBRETES, label: 'Lembretes', iconName: 'BellIcon' },
  { id: ADMIN_SECTION.PLANOS, label: 'Planos', iconName: 'CreditCardIcon' },
  { id: ADMIN_SECTION.DESPESAS, label: 'Despesas', iconName: 'BanknotesIcon' },
  { id: ADMIN_SECTION.PERIODIZACAO_LEMBRETES, label: 'Config. Lembretes', iconName: 'ClockIcon' },
  { id: ADMIN_SECTION.TERMOS_USO, label: 'Termos de Uso', iconName: 'DocumentTextIcon' },
  { id: ADMIN_SECTION.POLITICA_PRIVACIDADE, label: 'Política de Privacidade', iconName: 'ShieldCheckIcon' },
];

export interface AdminMenuGroup {
  label: string;
  sectionIds: AdminSectionId[];
}

export const ADMIN_MENU_GROUPS: AdminMenuGroup[] = [
  { label: 'Visão geral', sectionIds: [ADMIN_SECTION.DASHBOARD, ADMIN_SECTION.RELATORIOS] },
  {
    label: 'Operação',
    sectionIds: [ADMIN_SECTION.USUARIOS, ADMIN_SECTION.SERVICOS, ADMIN_SECTION.LEMBRETES],
  },
  {
    label: 'Configurações',
    sectionIds: [
      ADMIN_SECTION.PLANOS,
      ADMIN_SECTION.DESPESAS,
      ADMIN_SECTION.PERIODIZACAO_LEMBRETES,
      ADMIN_SECTION.TERMOS_USO,
      ADMIN_SECTION.POLITICA_PRIVACIDADE,
    ],
  },
];
